import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Avoid double-init
    if (window.fbq) return;
    const f = window;
    const b = document;
    const n = 'script';
    let e: HTMLScriptElement;
    const t = b.getElementsByTagName(n)[0];
    f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      f.fbq.callMethod ? f.fbq.callMethod.apply(f.fbq, arguments) : f.fbq.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = f.fbq;
    f.fbq.push = f.fbq;
    f.fbq.loaded = true;
    f.fbq.version = '2.0';
    f.fbq.queue = [];
    e = b.createElement(n) as HTMLScriptElement;
    e.async = true;
    e.src = 'https://connect.facebook.net/en_US/fbevents.js';
    t?.parentNode?.insertBefore(e, t);
    f.fbq('init', '937331855399019');
    f.fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = b.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=937331855399019&ev=PageView&noscript=1';
    b.body.appendChild(noscriptImg);
  }, []);
  return null;
}